<template>
  <div>
    <div class="top">
      <div class="title">产品出海，走向国际</div>
      <div class="value">浩顿出海导航服务，通过覆盖全亚洲及澳大利亚的医疗数据库，助力于本土医疗器械制造商的产品出海旅程，帮助其产品在海外市场落地。
      </div>
    </div>

    <div class="navigation">
      <div class="title">出海导航</div>
      <div class="value">
        <div class="icon">
          <div style="color:#f49700"><i class="el-icon-data-analysis"></i> 法规指引</div>
          <div style="color:#eb6628"><i class="el-icon-document-copy"></i> 政策避坑</div>
          <div style="color:#70be72"><i class="el-icon-guide"></i> 流程指导</div>
          <div style="color:#217fc4"><i class="el-icon-s-data"></i> 市场规模</div>
          <div style="color:#122a88"><i class="el-icon-office-building"></i> 竞争格局</div>
          <div style="color:#920683"><i class="el-icon-receiving"></i> 渠道分析</div>
        </div>

      </div>

    </div>

    <div class="characteristic">
      <div class="box">
        <div class="title" style="backgroundColor:#5ea6da">精 准</div>
        <div class="value">针对特定产品，分析对比多市场数据，精准掌握海外市场风向，选择最佳出海目的地。</div>
      </div>
      <div class="box">
        <div class="title" style="backgroundColor:#f5a833">迅 速</div>
        <div class="value">依托自有医患数据库和海外本土团队，在一周甚至更短时间为决策者提供值得信赖的数据支持并加速产品落地和盈利周期。</div>
      </div>
      <div class="box">
        <div class="title" style="backgroundColor:#a4cc4b">专 业</div>
        <div class="value">用国际标准个性化服务本土企业。经验丰富的研究和采访团队从海量数据中为您甄选最重要的个性化指标，提供产品出海的保姆级指导。</div>
      </div>
    </div>

    <div class="filtrate">
      <div class="title">
        第一步：市场筛选
      </div>
      <div class="value">
        <div class="arrowsone"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/arrows1.png" alt=""></div>
        <div class="arrowstwo"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/arrows2.png" alt=""></div>

        <div class="box one">
          <div class="subtitle" style="backgroundColor:#f6d699">
            <div class="num" style="backgroundColor:#f39801">1</div>
            <div class="text">市场透视</div>
          </div>
          <div class="detail" style="backgroundColor:#f6d699">涵盖从人口数据分析，到本地医疗系统，以及海外医保政策与政府规划介绍对比</div>
        </div>
        <div class="box two">
          <div class="subtitle" style="backgroundColor:#cce7d6">
            <div class="num" style="backgroundColor:#f39801">2</div>
            <div class="text">竞品分析</div>
          </div>
          <div class="detail" style="backgroundColor:#cce7d6">市场现有品牌排名，竟品价格分析，市场占有度调查和各类细分市场规模</div>
        </div>
        <div class="box three">
          <div class="subtitle" style="backgroundColor:#f8e5e1">
            <div class="num" style="backgroundColor:#f39801">3</div>
            <div class="text">数据总结</div>
          </div>
          <div class="detail" style="backgroundColor:#f8e5e1">现有市场产品壁垒，产品需求评估和系睬市场机会发掘</div>
        </div>
      </div>
    </div>

    <div class="filtrate fall">
      <div class="title">
        第二步：产品落地
      </div>
      <div class="value">
        <div class="arrowsthree"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/arrows3.png" alt=""></div>

        <div class="box one">
          <div class="subtitle" style="backgroundColor:#cbdfea">
            <div class="num" style="backgroundColor:#f39801">1</div>
            <div class="text">产品注册</div>
          </div>
          <div class="detail" style="backgroundColor:#cbdfea">解读当地法律法规，产品认证，产品开发以及知识产权转让风险和合规要求</div>
        </div>
        <div class="box two">
          <div class="subtitle" style="backgroundColor:#f0f5cc">
            <div class="num" style="backgroundColor:#f39801">2</div>
            <div class="text">经销商筛选</div>
          </div>
          <div class="detail" style="backgroundColor:#f0f5cc">销售渠道和销售平台信息汇总，当地经销商信息整理及对比</div>
        </div>

      </div>
    </div>
    <div class="map d-none d-sm-block">
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/worldmap.png" alt="">
      <div class="people">
        <div class="box one">
          <div class="photo">
            <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/djs/2022/10/17/6/1665975526976.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Alex Tam

            </div>
            <div class="market">中国香港</div>
            <div class="text">Alex在香港拥有丰富的医疗市场研究和咨询经验。他在医疗系统、市场准入政策以及治疗方面都有丰富的经验。

            </div>
          </div>
        </div>
        <div class="box two">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%872.png" alt="">
          </div>
          <div class="value">
            <div class="name">
              Baldwin Chia

            </div>
            <div class="market">新加坡</div>
            <div class="text">Baldwin不仅能为我们带来了市场研究的见解，还带来了商业见解和战略，他为大量本地和国际客户提供端到端的解决方案。

            </div>
          </div>
        </div>
        <div class="box three">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Jeffrey Kelsch

            </div>
            <div class="market">美国</div>
            <div class="text">Jeff在医疗保健研究方面有30多年的经验，他致力于帮助客户进入西方市场，增加其在西方市场的占有率。

            </div>
          </div>
        </div>
        <div class="box four">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2023/02/22/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Angela Wang

            </div>
            <div class="market">中国台湾</div>
            <div class="text">Angela是台湾著名的医疗器械产品营销专家，她拥有30年的经验，可以帮助客户完成他们的营销研究需求，解决营销问题。
            </div>
          </div>
        </div>
        <div class="box five">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%873.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Gaku Sasaki
            </div>
            <div class="market">日本</div>
            <div class="text">Gaku-san是日本当地极具声望的医疗保健行业市场顾问，他拥有25年行业经验，善于向国际客户沟通日本市场的见解。
            </div>
          </div>
        </div>
        <div class="box six">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/scott.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Nicola Scott

            </div>
            <div class="market">澳大利亚</div>
            <div class="text">Nicola善于为品牌寻找机会，并利用研究结果帮助公司最大限度地提高其产品与市场需求的相关性，提高其吸引力，最终推动其在澳大利亚市场的商业成功。
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="mobilemap d-block d-sm-none">
      <!-- <img src="@/assets/img/worldmap.png" alt=""> -->
      <div class="people">
        <div class="box one">
          <div class="photo">
            <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/djs/2022/10/17/6/1665975526976.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Alex Tam

            </div>
            <div class="market">中国香港</div>
            <div class="text">Alex在香港拥有丰富的医疗市场研究和咨询经验。他在医疗系统、市场准入政策以及治疗方面都有丰富的经验。

            </div>
          </div>
        </div>
        <div class="box two">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%872.png" alt="">
          </div>
          <div class="value">
            <div class="name">
              Baldwin Chia

            </div>
            <div class="market">新加坡</div>
            <div class="text">Baldwin不仅能为我们带来了市场研究的见解，还带来了商业见解和战略，他为大量本地和国际客户提供端到端的解决方案。

            </div>
          </div>
        </div>
        <div class="box three">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Jeffrey Kelsch

            </div>
            <div class="market">美国</div>
            <div class="text">Jeff在医疗保健研究方面有30多年的经验，他致力于帮助客户进入西方市场，增加其在西方市场的占有率。

            </div>
          </div>
        </div>
        <div class="box four">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2023/02/22/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Angela Wang

            </div>
            <div class="market">中国台湾</div>
            <div class="text">Angela是台湾著名的医疗器械产品营销专家，她拥有30年的经验，可以帮助客户完成他们的营销研究需求，解决营销问题。
            </div>
          </div>
        </div>
        <div class="box five">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%873.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Gaku Sasaki
            </div>
            <div class="market">日本</div>
            <div class="text">Gaku-san是日本当地极具声望的医疗保健行业市场顾问，他拥有25年行业经验，善于向国际客户沟通日本市场的见解。
            </div>
          </div>
        </div>
        <div class="box six">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/scott.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Nicola Scott

            </div>
            <div class="market">澳大利亚</div>
            <div class="text">Nicola善于为品牌寻找机会，并利用研究结果帮助公司最大限度地提高其产品与市场需求的相关性，提高其吸引力，最终推动其在澳大利亚市场的商业成功。
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="end">
      浩顿全球专家 当地市场领航员，
      为您的产品出海之旅 保驾护航！

    </div>
  </div>
</template>

<script>
import { advertisementFlow } from "@/api/api";
export default {
  data() {
    return {};
  },
  methods: {
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "international",
          source: "",
          information: "产品出海"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "international",
          source: this.$route.query.source,
          information: "产品出海"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  padding: 50px 120px;
  background-color: #a0c2ec;

  .title {
    color: #fff;
    font-size: 45px;
    font-weight: 700;
  }
  .value {
    color: #fff;
    text-align: center;
    // width: 80%;
    font-size: 25px;
    padding: 50px;
  }
}
.navigation {
  padding: 50px 120px;
  .title {
    color: #2cb1e9;

    font-size: 45px;
    font-weight: 700;
  }
  .value {
    padding: 0 300px;
    .icon {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      div {
        width: 30%;
        font-size: 30px;
        text-align: center;
        margin: 10px 0;
      }
    }
  }
}
.map {
  padding: 250px 120px;

  position: relative;
  img {
    width: 100%;
  }
  .people {
    //  position: absolute;
    .one {
      top: 5%;
      left: 20%;
    }
    .two {
      top: 40%;
      left: 7%;
    }
    .three {
      top: 70%;
      left: 20%;
    }
    .four {
      top: 5%;
      left: 55%;
    }
    .five {
      top: 40%;
      left: 70%;
    }
    .six {
      top: 70%;
      left: 55%;
    }
    .box {
      position: absolute;
      width: 300px;
      .photo {
        position: absolute;
        right: -25%;
        top: -25%;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 2px solid #428cca;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .value {
        border: 2px solid #428cca;
        width: 350px;
        height: 170px;
        padding: 10px;
        background-color: #efefef;
        .name,
        .market {
          font-weight: 700;
          font-size: 20px;
        }
      }
    }
  }
}
.end {
  padding: 0 120px;
  margin-bottom: 120px;
  text-align: center;
  font-size: 35px;
  font-weight: 700;
}
.characteristic {
  padding: 50px 120px;
  .box {
    display: flex;
    align-items: center;
    height: 100px;
    // border: 1px solid #000;

    background-color: #2180c4;
    border-radius: 20px;
    color: #fff;
    box-shadow: 1px 1px 5px rgb(102, 101, 101);
    margin: 50px 0;
    .title {
      width: 15%;
      text-align: center;
      // border: 1px solid #000;
      font-size: 35px;
      border-radius: 20px;
      margin-right: 20px;
      line-height: 100px;
      font-weight: 700;
      // background-color: #5ea6da;
      box-shadow: 1px 1px 5px #000;
    }
    .value {
      font-size: 25px;
      width: 85%;
      padding-right: 20px;
    }
  }
}
.filtrate {
  padding: 50px 120px;
  .title {
    font-size: 30px;
    color: #388dc9;
    font-weight: 700;
  }
  .value {
    position: relative;
    height: 500px;
    .box {
      width: 300px;
      height: 150px;
      position: absolute;
      .subtitle {
        font-weight: 700;
        display: flex;
        text-align: center;
        align-items: center;
        border: 3px solid #fff;
        position: absolute;
        border-radius: 30px;
        padding: 10px;
        padding-left: 0;
        height: 50px;
        font-size: 20px;
        z-index: 1;
        top: -15%;
        left: 25%;
        .num {
          color: #fff;
          width: 50px;
          height: 50px;
          line-height: 50px;
          border-radius: 30px;
          margin-right: 10px;
          border: 1px solid #fff;
        }
      }
      .detail {
        font-size: 20px;
        padding: 30px;
        width: 300px;
      }
    }
    .one {
      top: 15%;
      left: 18%;
    }
    .two {
      top: 40%;
      left: 55%;
    }
    .three {
      top: 75%;
      left: 18%;
    }
  }
  .arrowsone {
    position: absolute;
    width: 150px;
    top: 20%;
    left: 45%;
    img {
      width: 100%;
    }
  }
  .arrowstwo {
    position: absolute;
    width: 100px;
    top: 75%;
    left: 48%;
    img {
      width: 100%;
    }
  }
  .arrowsthree {
    position: absolute;
    width: 150px;
    top: 18%;
    left: 45%;
    img {
      width: 100%;
    }
  }
}
.fall {
  .value {
    height: 400px;
  }
}
@media screen and (max-width: 576px) {
  .top {
    .title {
      font-size: 80px;
    }
    .value {
      font-size: 70px;
    }
  }
  .navigation {
    .title {
      font-size: 80px;
    }
    .value {
      padding: 50px 0;
      .icon {
        div {
          width: 33%;
          font-size: 60px;
        }
      }
    }
  }
  .mobilemap {
    background: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/worldmap.png") no-repeat;
    background-size: contain;
    height: 1150px;

    margin: 50px 120px;

    background-position: center center;

    .people {
      height: 1050px;
      padding-top: 100px;
      overflow-y: auto;
      .box {
        width: 80%;
        margin: 0 auto;
        position: relative;
        margin-bottom: 140px;
        .photo {
          position: absolute;
          right: -50px;
          top: -100px;
          width: 300px;
          height: 300px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .value {
          background-color: rgba(255, 255, 255, 0.8);
          border: 7px solid #428cca;
          padding: 30px;
          .name,
          .market {
            font-size: 60px;
          }
          .text {
            font-size: 50px;
          }
        }
      }
    }
  }
  .people::-webkit-scrollbar {
    display: none;
  }
  .end {
    font-size: 60px;
  }
  .characteristic {
    .box {
      height: 320px;
      .title {
        font-size: 80px;
        height: 320px;
        line-height: 320px;
        width: 25%;
      }
      .value {
        font-size: 50px;
      }
    }
  }
  .filtrate {
    .title {
      font-size: 70px;
    }
    .value {
      height: 1200px;
      .box {
        width: 600px;
        height: 300px;
        .subtitle {
          font-size: 50px;
          height: 100px;
          left: 20%;
          border-radius: 50px;
          .num {
            width: 100px;
            height: 100px;
            border-radius: 50px;
            line-height: 100px;
          }
        }
        .detail {
          width: 600px;
          font-size: 50px;
          padding-top: 70px;
        }
      }
      .one {
        left: 0;
      }
      .three {
        left: 0;
      }
    }
    .arrowsone {
      width: 200px;
      left: 50%;
    }
    .arrowstwo {
      width: 150px;
      left: 50%;
      top: 80%;
    }
    .arrowsthree {
      width: 200px;
      left: 50%;
      top: 20%;
    }
  }
  .fall {
    .value {
      height: 1000px;
    }
  }
}
</style>